import React from 'react';

import CommonImage from '@components/CommonImage';

const DesignCard = ({ design, onOpenDesignView, onLikeProduct, QRLikedDesignIds }) => {
	return (
		<div className="single-style-item">
			<div className="single-design-card with-editable ">
				<div className="card-top">
					<CommonImage
						src={design?.designDocuments[0]?.docUrl}
						className="card-image"
						alt={design?.referenceNumber}
						isStatic={false}
					/>

					<div className="action-btns d-flex flex-column align-items-center">
						<button
							className="button outline view-teckpack-button bg-white size32"
							onClick={() => onOpenDesignView(design)}
						>
							Techpack
						</button>
						{QRLikedDesignIds?.includes(design?.id) || design?.liked ? (
							<div
								className="added-btn d-flex align-items-center justify-content-center"
								style={{ visibility: 'visible' }}
							>
								<CommonImage src="/icons/Check-large.svg" width="20" height="20" alt="" />
								<p className="regular-14 green pl-1">Added</p>
							</div>
						) : (
							<button
								className="button view-load-button size32"
								onClick={() => onLikeProduct(design?.id)}
							>
								Add
							</button>
						)}
					</div>
				</div>
				<div className="card-content">
					<div className="card-info">
						<div className="">
							<h3 className="title-number semibold-12 mb-1">
								{design?.referenceNumber} {design?.brandName}
							</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DesignCard;
